<div class="flex items-center">
  <auto-editor-ratenow-ui-breadcrumb>
    <a [routerLink]="['/']" class="is-navigable">
      <mat-icon [svgIcon]="'mat:home'" class="icon-sm"></mat-icon>
    </a>
  </auto-editor-ratenow-ui-breadcrumb>
  @if (breadcrumbs && breadcrumbs.length > 0) {
    @for (crumb of breadcrumbs; track crumb; let i = $index) {
      <div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2"></div>
      <auto-editor-ratenow-ui-breadcrumb>
        @if (crumb?.url) {
          <a
            [routerLink]="crumb?.url"
            [ngClass]="{
              'is-navigable ': crumb.url !== '/',
              'not-navigable ': crumb.url === '/'
            }"
          >
            {{ crumb?.label }}
          </a>
        }
      </auto-editor-ratenow-ui-breadcrumb>
    }
  }
</div>
